import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { PainSection } from '../components/sections/PainSection';
import { TruthSection } from '../components/sections/TruthSection';
import { ProductSection } from '../components/sections/ProductSection';
import { ExamplesSection } from '../components/sections/ExamplesSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { ObjectionSection } from '../components/sections/ObjectionSection';
import { FuturePacingSection } from '../components/sections/FuturePacingSection';
import { OfferSection } from '../components/sections/OfferSection';
import { PricingSection } from '../components/sections/PricingSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { UrgencySection } from '../components/sections/UrgencySection';
import { FAQSection } from '../components/sections/FAQSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-313">
      <HeroSection data-id="element-314" />
      <PainSection data-id="element-315" />
      <TruthSection data-id="element-316" />
      <OfferSection data-id="element-317" />
      <ProductSection data-id="element-318" />
      <ExamplesSection data-id="element-319" />
      <FeaturesSection data-id="element-320" />
      <ObjectionSection data-id="element-321" />
      <FuturePacingSection data-id="element-322" />
      <PricingSection data-id="element-323" />
      <GuaranteeSection data-id="element-324" />
      <UrgencySection data-id="element-325" />
      <FAQSection data-id="element-326" />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12" data-id="element-327">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-328">
          <p className="text-lg mb-4" data-id="element-329">A Fórmula do Efeito Boutique™</p>
          <p className="text-gray-400 text-sm" data-id="element-330">
            © 2024 Todos os direitos reservados. | Política de Privacidade |
            Termos de Uso
          </p>
        </div>
      </footer>
    </div>;
}